export enum AuthenticateAdmin {
    AdminCitra = 'citra@strongbee.co.id',
    AdminFarah = 'farah@strongbee.co.id'
}
